module.exports = __webpack_public_path__ + "img/km.eb69abb6.svg";